import { assign } from 'lodash';
import createReducer from './baseReducer';

const conditions = {
  REQUEST_UPDATE_SETTINGS: (state, data, error) =>
    assign({}, state, {
      isFetching: true,
      error: false,
    }),
  RECEIVE_UPDATE_SETTINGS: (state, data, error) =>
    assign({}, state, {
      error,
      isFetching: false,
      settings: data,
    }),
};

export default createReducer('settings', 'setting', 'settings', conditions);
